import { useEffect, useState } from "react";
import { paths } from "../../../paths/paths";
import Bullets from "../../sharedComponents/bullets/bullets";
import { setMemberStatus } from "../../../API/store/actions/projects/projects";

const ActivityStatusCard = ({
  member,
  status,
  procAdded,
  setProcAdded,
  userToken,
  activityId,
}) => {
  const [currentStatus, setCurrentStatus] = useState(member?.taskStatusId); //////////
  // const userToken = useSelector((state) => state.login.userToken);

  useEffect(() => {
    setMemberStatus(member.id, currentStatus, userToken);
  }, [currentStatus]);

  return (
    <>
      <div className="d-flex flex-column flex-lg-row justify-content-between px-3 mt-2">
        <div className="d-flex align-items-center justify-content-start col-lg-9 col-12">
          <img
            className="img-fluid"
            style={{ borderRadius: "50%", width: 30 }}
            src={
              member?.memberPhoto
                ? `${paths.MemberPhoto}${member?.memberId}/${member?.memberPhoto}`
                : "/assets/images/userPlaceholder.png"
            }
          />
          <div className="my-0 mx-3" style={{ fontWeight: "bold" }}>
            {member?.memberName}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center col-lg-3 mt-lg-0 col-12 mt-3">
          {status?.data?.statusLkp.map((item, index) => {
            return (
              <div className="mx-2">
                <Bullets
                  key={index}
                  memberId={member.memberId}
                  procAdded={procAdded}
                  setProcAdded={setProcAdded}
                  id={item.id}
                  borderColor={"#1a73e8"}
                  bulletColor={item?.color}
                  tooltipTitle={item?.name}
                  setActive={setCurrentStatus}
                  active={currentStatus}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-center px-2">
        <hr className="col-12 my-2" style={{ backgroundColor: "#707070" }}></hr>
      </div>
    </>
  );
};

export default ActivityStatusCard;
